const deepExtends = (dest, src) =>
  Object
    .keys(src)
    .reduce((acc, key) => {
      acc[key] = acc[key] || {};
      Object.assign(acc[key], dest[key] || {}, src[key] || {});
      return acc;
    }, dest);

const FIELDS = ['components', 'directives', 'filters'];

const createAsyncResolver = (mod, type, name) => async () => {
  const exports = await mod.module();
  return exports.default[type][name];
};

const registerAsyncFieldName = (acc, mod, type, name) => {
  acc[type][name] = createAsyncResolver(mod, type, name);
};

const registerAsyncField = (acc, mod, type) => {
  if (!mod[type]) {
    return;
  }

  [].concat(mod[type]).forEach((name) => {
    registerAsyncFieldName(acc, mod, type, name);
  });
};

const registerAsyncImport = (acc, mod) => {
  FIELDS.forEach((type) => {
    registerAsyncField(acc, mod, type);
  });
};

const processAsyncImports = (acc, asyncImports) => {
  [].concat(asyncImports).forEach((mod) => {
    registerAsyncImport(acc, mod);
  });
};

const processImports = (acc, imports) => {
  imports.forEach((mod) => {
    deepExtends(acc, mod);
  });
};

const applyModuleOption = (acc, key, moduleOptions) => {
  switch (key) {
    case 'asyncImports':
      processAsyncImports(acc, moduleOptions[key]);
      break;
    case 'imports':
      processImports(acc, moduleOptions[key]);
      break;
    case 'directives':
    case 'components':
    case 'filters':
      Object.assign(acc[key], moduleOptions[key]);
      break;
    default:
      acc[key] = moduleOptions[key];
      break;
  }

  return acc;
};

/**
 *
 * @param moduleOptions
 * @returns {{components: {}, directives: {}, filters: {}}}
 * @constructor
 */
export function VueModule(moduleOptions) {
  return Object.keys(moduleOptions).reduce((acc, key) => (
    applyModuleOption(acc, key, moduleOptions)
  ), { components: {}, directives: {}, filters: {} });
}
